import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { AssabilMenu } from 'src/app/assabil-kernel/models/entities/control-tables/assabil-menu';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'assabil-menu-lov',
    templateUrl: './assabil-menu-lov.component.html',
    styleUrls: ['./assabil-menu-lov.component.scss']
})


export class AssabilMenuLovComponent extends GenericLovComponent {

code     : string; 
name     : string; 

assabilMenus          : AssabilMenu[] = [];

columns = [
    {  prop: 'assabilMenuCode', name: 'Code'},
    {  prop: 'name',            name: 'Name'               }
]

constructor(
    public dialogRef: MatDialogRef<AssabilMenuLovComponent>,
    protected controlService    : ControlTablesService,
    protected toastr            : ToastrService,
    protected router            : Router,
    protected location          : Location) {
        super();
        this.entityName = "assabilMenu";
}

//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlService.getUserInfo());
        request.strArg1 = this.code;
        request.strArg2 = this.name;

        this.controlService.getList( this.entityName, request).then(result => {
            this.assabilMenus = result;
        })
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  closeModal(assabilMenu : AssabilMenu){
    this.dialogRef.close(assabilMenu);
  }
//----------------------------------------------------------------------
}
